import React from 'react';
import { Col, Row } from 'reactstrap';
import DateRangePickerComponent from '../DaterangePicker';
import ReportExportButton from './ReportExportButton';

const ReportHeader = ({
	range,
	onDateChange,
	reportKey,
	sortField,
	sortBy,
	sortOrder,
}) => {
	return (
		<React.Fragment>
			<Row className="mt-3 align-items-center justify-content-between">
				<Col xs="auto">
					<h2>Reports</h2>
				</Col>
				<Col xs="12" md="auto" className="reportHeaderToolbar">
					<DateRangePickerComponent
						dateRange={range}
						onSelect={(selected) => onDateChange(selected)}
					/>
					{reportKey ? (
						<ReportExportButton
							reportKey={reportKey}
							sortField={sortField}
							sortBy={sortBy}
							sortOrder={sortOrder}
						/>
					) : null}
				</Col>
			</Row>
		</React.Fragment>
	);
};

export default ReportHeader;
